export default __webpack_public_path__ + "resources/icons/n222-fac3.webp";